import { observer } from 'mobx-react-lite'
import { links } from '@/utils/link'
import { type WorkspaceApplicantItemViewModel } from '@/features/admin/staffing/components/ApplicantManagementPanel/WorkspaceApplicantItemViewModel'
import { type ApplicantManagementColumnDetails } from '@/features/admin/staffing/components/ApplicantManagementTable/applicant-management-table-columns'
import { ApplicantManagementTableRow } from '@/features/admin/staffing/components/ApplicantManagementTableRow'
import {
  formatManagedWorkspaceApplicantStatus,
  workspaceApplicantStatusVariant,
} from '@/features/admin/staffing/workspace-posting-formatters'
import { getProviderTypeTitle } from '@/features/iam/providers/provider-display'

export interface ApplicantManagementTableRowContainerProps {
  vm: WorkspaceApplicantItemViewModel
  columns: ApplicantManagementColumnDetails[]
}

export const ApplicantManagementTableRowContainer = observer(
  function ApplicantManagementTableRowContainer({
    vm,
    columns,
  }: ApplicantManagementTableRowContainerProps) {
    const applicant = vm.applicant
    return (
      <ApplicantManagementTableRow
        columns={columns.map((column) => ({
          id: column.id,
          align: column.align,
        }))}
        userPublicId={applicant.userPublicId}
        userDetailsLink={links.userDetails(applicant.userPublicId)}
        isSelected={vm.isSelected}
        onToggleSelected={vm.toggleSelected}
        displayName={applicant.displayName}
        avatar={applicant.avatar}
        proManager={applicant.provider.proManager}
        proTypeTitle={getProviderTypeTitle(applicant.provider.proType)}
        stateRegion={applicant.provider.stateRegion}
        yearsExperience={applicant.provider.yearsExperience}
        totalWorkspaces={applicant.provider.workspaces.length}
        displayStatus={formatManagedWorkspaceApplicantStatus(applicant.status)}
        statusVariant={workspaceApplicantStatusVariant(applicant.status)}
        canInvite={vm.canInvite}
        canRescindInvitation={vm.canRescindInvitation}
        onInvite={vm.invite}
        onRescindInvitation={vm.rescindInvitation}
      />
    )
  },
)
